import { render, staticRenderFns } from "./SidenavDivider.vue?vue&type=template&id=7c6f13b4&"
import script from "./SidenavDivider.vue?vue&type=script&lang=js&"
export * from "./SidenavDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports